import Wallet from '@/common-pages/wallet';
import {Button} from 'antd-mobile';
import NavTitle from '@/components/basic/nav-title';
import globalStore from '@/services/global.state';
import theme from '@/style';
import {BasicObject} from '@/types';
import {goTo} from '@/utils';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Image, View} from 'react-native';
import {Shadow} from 'react-native-shadow-2';
import {combineLatest} from 'rxjs';
import styles from './home-header.module.scss';
import {useScreenSize} from '@/common-pages/hooks/size.hooks';

const shadow = {
  startColor: 'rgba(0, 0, 0, 0.25)',
  distance: 4,
  offset: [0, 1],
  style: [theme.borderRadius.m, theme.overflow.hidden] as BasicObject[],
} as BasicObject;

if (globalStore.isWeb) {
  shadow.distance = 0;
  delete shadow.offset;
  shadow.style.push({
    boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
  });
}

const SearchEntry = () => {
  const goSearch = () => {
    goTo('search');
  };
  return (
    <img
      src={require('@/assets/icons/home/search.png')}
      className="w-6 h-6"
      onClick={goSearch}
    />
  );
};

const HomeHeader = () => {
  const {i18n} = useTranslation();
  const [hasLogin, setHasLogin] = useState(false);
  const {calcActualSize} = useScreenSize();
  React.useEffect(() => {
    const tokenSub = combineLatest([globalStore.tokenSubject]).subscribe(
      ([t]) => {
        setHasLogin(!!t);
      },
    );
    return () => {
      tokenSub.unsubscribe();
    };
  }, []);
  return (
    <NavTitle showProgress containerStyle={[theme.background.dark]}>
      <View style={[theme.flex.row, theme.flex.centerByCol]}>
        <Image
          source={require('@assets/imgs/home/header_bg.webp')}
          style={[
            theme.margin.rightxxs,

            {
              width: calcActualSize(139),
              height: calcActualSize(40),
            },
          ]}
        />
      </View>
      <View style={[theme.flex.flex1]} />
      {hasLogin ? (
        <div className="flex gap-2 items-center">
          <Wallet theme="dark" />
          <SearchEntry />
        </div>
      ) : (
        <div className="flex gap-2 items-center">
          <Shadow {...shadow}>
            <div className="flex flex-row gap-2">
              <Button
                onClick={() => goTo('Login')}
                // buttonStyle={[theme.background.accent, theme.padding.lrpxxl]}
                // radius={24}
                // radius={theme.borderRadiusSize.xl}
                // title={i18n.t('login.label.login')}
                // textColor="var(--T1)"
                // size="headerbg"
                // style={{
                //   ...theme.background.accent,
                //   // paddingTop: theme.paddingSize.xs,
                //   // paddingBottom: theme.paddingSize.xs,
                //   // paddingLeft: theme.paddingSize.xs,
                //   // paddingRight: theme.paddingSize.xs,
                //   borderRadius: theme.borderRadiusSize.xl,
                // }}
                className={`${styles.bg_btn} ${styles.bg_login}`}
                // size="small"
              >
                {i18n.t('login.label.login')}
              </Button>
              <Button
                onClick={() => goTo('SingUp')}
                // style={{
                //   ...theme.background.headerBG,
                //   // padding: theme.paddingSize.xl,
                //   borderRadius: theme.borderRadiusSize.xl,
                // }}
                // size="small"
                className={`${styles.bg_btn} ${styles.bg_register}`}>
                {i18n.t('login.label.register')}
              </Button>
            </div>
          </Shadow>
          <SearchEntry />
        </div>
      )}
    </NavTitle>
  );
};
export default HomeHeader;
